// Route paths
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

// Navigation items
export interface NavItem {
  label: string;
  href: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'The Protocol', href: '#protocol' },
  { label: 'The Three Pillars', href: '#pillars' },
  { label: 'Who We Are', href: '#about' },
  { label: 'Begin', href: '#contact' },
];

// Pillar type
export interface Pillar {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  items: string[];
}

export const PILLARS: Pillar[] = [
  {
    number: 'I',
    title: 'Water Excellence',
    subtitle: 'The first element.',
    description:
      'Water is the foundation of life. On a yacht, in a villa, at a restaurant table — the quality of the water you drink, cook with, and clean with shapes every experience. We work only with structured, ionized, or filtered water systems that are scientifically sound and sea-worthy.',
    items: [
      'Ionized & structured water systems',
      'Marine-grade equipment',
      'Yacht, catamaran, villa, restaurant',
      'Zero compromise on quality',
    ],
  },
  {
    number: 'II',
    title: 'Pure Living',
    subtitle: 'What touches your skin. What fills your lungs.',
    description:
      'The products that surround us — cleaning agents, personal care, fabrics — carry an invisible chemical load. Pure Living means replacing them one by one with honest alternatives: non-toxic, effective, and kind to the ocean we live beside.',
    items: [
      'Non-toxic cleaning products',
      'Indoor air quality',
      'Personal care & skin',
      'Ocean-safe formulations',
    ],
  },
  {
    number: 'III',
    title: 'Earth & Air',
    subtitle: 'Close the loop.',
    description:
      'In the Caribbean, waste is not an abstraction — it is the reef dying next door. Earth & Air addresses what happens at the end: composting systems, humidity management, and the quiet intelligence of working with natural cycles rather than against them.',
    items: [
      'Composting systems on land & sea',
      'Dehumidification & mold prevention',
      'Indoor air quality monitoring',
      'Circular living practices',
    ],
  },
];

// Environments
export interface Environment {
  icon: string;
  title: string;
  description: string;
}

export const ENVIRONMENTS: Environment[] = [
  {
    icon: '⚓',
    title: 'Yacht',
    description: 'High-performance water systems and non-toxic products for offshore living.',
  },
  {
    icon: '⛵',
    title: 'Catamaran',
    description: 'Space-efficient solutions for live-aboard comfort and sustainability.',
  },
  {
    icon: '🌿',
    title: 'Private Villa',
    description: 'Whole-home protocols — water, air, and soil — for land-based sanctuaries.',
  },
  {
    icon: '🍃',
    title: 'Restaurant',
    description: 'Kitchen-grade water excellence and clean supply chains for conscious hospitality.',
  },
];
